<template>
    <Header></Header>

    <div class="container sub_page _activity">
        <section class="sub_page_tit">
            <div class="deco_wrap">
                <i class="deco_01"><img src="img/activity_left.png" /></i>
                <i class="deco_02 _small blink4"><img src="img/b_icon_01.png" /></i>
                <i class="deco_03 _small blink_zoom1"><img src="img/b_icon_02.png" /></i>
                <i class="deco_04 _xxsmall blink_zoom4"><img src="img/b_icon_05.png" /></i>
                <i class="deco_05 none_768 spin2 _medium"><img src="img/b_icon_03.png" /></i>
                <i class="deco_06 none_768 spin_blink3 _small"><img src="img/b_icon_01.png" /></i>
                <i class="deco_07 none_768 blink_zoom4 _small"><img src="img/b_icon_02.png" /></i>
                <i class="deco_character"><img src="img/activity_icon.png" /></i>
            </div>
            <div class="banner_wrap wrap_1120">
                <h2>시민참여 활동</h2>
            </div>

            <div class="sub_menu_tab wrap_1120">
                <button class="only_768" @click="subMenuTab" :class="{ active: state.subMenuOpen }">{{ state.subMenuName }}</button>
                <ul :class="{ active: state.subMenuOpen }">
                    <li @click="changeTab(1)" :class="[state.tab === 1 ? 'active' : '']"><a href="javascript:void(0)">반성매매 시민활동</a></li>
                    <li @click="changeTab(2)" :class="[state.tab === 2 ? 'active' : '']"><a href="javascript:void(0)">캠페인·이벤트</a></li>
                    <li @click="changeTab(3)" :class="[state.tab === 3 ? 'active' : '']">
                        <a href="javascript:void(0)">참여하고 싶은 반성매매 활동 제안</a>
                    </li>
                    <li
                        v-if="user.isLogin()"
                        @click="
                            changeTab(4);
                            state.stateIdx = 0;
                        "
                        :class="[state.tab === 4 ? 'active' : '']"
                        class="w_1024_custom_width"
                    >
                        <a href="javascript:void(0)">액션 시민 활동</a>
                    </li>
                </ul>
            </div>
        </section>

        <ActivityList v-if="state.tab === 1"></ActivityList>
        <EventList v-else-if="state.tab === 2"></EventList>
        <SuggestList v-else-if="state.tab === 3"></SuggestList>
        <template v-else>
            <ActionList v-if="state.tab === 4 && state.stateIdx && user.isLogin()" :stateIdx="state.stateIdx"></ActionList>
            <ActionState v-if="state.tab === 4 && !state.stateIdx && user.isLogin()" @selectState="selectState"></ActionState>
        </template>
    </div>

    <Footer></Footer>
</template>

<script lang="ts" config>
    import {
        Header,
        Footer,
        reactive,
        globalStore,
        onMounted,
        watch,
        activityList,
        eventList,
        suggestList,
        useRoute,
        router,
        actionList,
        userStore,
        actionState,
    } from "@/BaseComponent";

    export default {
        components: {
            Header,
            Footer,
            ActivityList: activityList,
            EventList: eventList,
            SuggestList: suggestList,
            ActionState: actionState,
            ActionList: actionList,
        },
        setup() {
            const global = globalStore();
            const route = useRoute();
            const user = userStore();
            const state = reactive({
                tab: 0 as number,
                stateIdx: 0 as number,
                subMenuOpen: false,
                subMenuName: "반성매매 시민활동" as string,
            });

            onMounted(() => {
                const type = Number(route.query.type);
                const stateIdx = Number(route.query.idx);
                if (route.query.type) {
                    if (type && typeof type === "number" && !isNaN(type)) state.tab = type;
                    else state.tab = 1;
                } else state.tab = 1;
                if (route.query.idx && state.tab === 4) {
                    if (stateIdx && typeof stateIdx === "number" && !isNaN(stateIdx)) state.stateIdx = stateIdx;
                } else state.stateIdx = 0;

                changeTab(state.tab);
            });

            watch(
                () => [route.query.type],
                () => {
                    const type = Number(route.query.type);
                    const stateIdx = Number(route.query.idx);
                    if (route.query.type) {
                        if (type && typeof type === "number" && !isNaN(type)) state.tab = type;
                        else state.tab = 1;
                    } else state.tab = 1;

                    if (route.query.idx && state.tab === 4) {
                        if (stateIdx && typeof stateIdx === "number" && !isNaN(stateIdx)) state.stateIdx = stateIdx;
                    } else state.stateIdx = 0;
                    changeTab(state.tab);
                },
            );

            const changeTab = (tab: number) => {
                state.tab = tab;
                if (tab === 4 && !user.isLogin()) state.tab = 1;
                if (state.stateIdx) {
                    router.push({ path: "/board", query: { type: state.tab, idx: state.stateIdx } });
                } else {
                    router.push({ path: "/board", query: { type: state.tab } });
                }
                state.subMenuOpen = false;
                switch (tab) {
                    case 1:
                        state.subMenuName = "반성매매 시민활동";
                        break;
                    case 2:
                        state.subMenuName = "캠페인·이벤트";
                        break;
                    case 3:
                        state.subMenuName = "참여하고 싶은 반성매매 활동 제안";
                        break;
                    case 4:
                        state.subMenuName = "액션 시민 활동";
                        break;
                }
            };

            const subMenuTab = () => {
                if (window.innerWidth <= 768) {
                    state.subMenuOpen = !state.subMenuOpen;
                }
            };

            const selectState = (idx: number) => {
                state.stateIdx = idx;
                changeTab(4);
            };

            return { user, global, state, changeTab, subMenuTab, selectState };
        },
    };
</script>
